/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowAUpRightIcon16Light } from './ArrowAUpRightIcon16Light';
import { ArrowAUpRightIcon16Regular } from './ArrowAUpRightIcon16Regular';
import { ArrowAUpRightIcon16Solid } from './ArrowAUpRightIcon16Solid';
import { ArrowAUpRightIcon20Light } from './ArrowAUpRightIcon20Light';
import { ArrowAUpRightIcon20Regular } from './ArrowAUpRightIcon20Regular';
import { ArrowAUpRightIcon20Solid } from './ArrowAUpRightIcon20Solid';
import { ArrowAUpRightIcon24Regular } from './ArrowAUpRightIcon24Regular';
import { ArrowAUpRightIcon24Solid } from './ArrowAUpRightIcon24Solid';
import { ArrowAUpRightIcon32Regular } from './ArrowAUpRightIcon32Regular';
import { ArrowAUpRightIcon64Regular } from './ArrowAUpRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowAUpRightIcon16Light,
        regular: ArrowAUpRightIcon16Regular,
        solid: ArrowAUpRightIcon16Solid,
    },
    20: {
        light: ArrowAUpRightIcon20Light,
        regular: ArrowAUpRightIcon20Regular,
        solid: ArrowAUpRightIcon20Solid,
    },
    24: {
        regular: ArrowAUpRightIcon24Regular,
        solid: ArrowAUpRightIcon24Solid,
    },
    32: {
        regular: ArrowAUpRightIcon32Regular,
    },
    64: {
        regular: ArrowAUpRightIcon64Regular,
    },
};
export var ArrowAUpRightIcon = forwardRef('ArrowAUpRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
